import React from "react"
import { useIgloonetFiles } from "../hooks/use-igloonet-files"
import { GenericProfileImage } from "@igloonet-web/shared-ui"

const ProfileImage: React.FC<ProfileImageProps> = (props) => {
  return <GenericProfileImage allImages={useIgloonetFiles()} {...props} />
}

export default ProfileImage
